@import '@helsenorge/designsystem-react/scss/_spacers.scss';
@import '@helsenorge/designsystem-react/scss/_breakpoints.scss';

$chatbot-primary-color: #6a2abf;
$chatbot-secondary-color: #9153e2;

.chatbot {
  max-width: 12rem;
  position: fixed;
  opacity: 1;
  visibility: visible;
  bottom: 2rem;
  right: 2rem;
  left: auto;
  z-index: 90000; // Selve chaten har z-index 100000, Chat-knappen skal ligge bak

  @media (min-width: map-get($grid-breakpoints, md)) {
    max-width: unset;
  }

  &__button {
    padding: 1.35rem 3rem;
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
    background-color: $chatbot-primary-color;
    font-size: 1.125rem;
    font-style: normal;
    font-weight: 600;
    line-height: 1.15;
    color: white;
    border: 2px solid white;
    box-shadow: 0px 0px 4px 4px rgba(98, 98, 95, 0.4);
    border-radius: 0.5rem;
    cursor: pointer;
    z-index: 90001;

    &:focus,
    &:hover {
      outline: none;
      box-shadow: 0 0 0 8px $chatbot-secondary-color;
    }
    @media (min-width: map-get($grid-breakpoints, md)) {
      font-size: 1.25rem;
      padding: 1.25rem 2.5rem;
    }
  }

  &__icon {
    display: none;
    width: 60px;
    margin-right: 20px;
    @media (min-width: map-get($grid-breakpoints, md)) {
      display: inline;
    }
  }

  &__close {
    position: absolute;
    top: -1.375rem;
    right: -1.375rem;
    width: 2.75rem;
    height: 2.75rem;
    cursor: pointer;
    background-color: white;
    border: 2px solid $chatbot-primary-color;
    border-radius: 50%;
    z-index: 90002;

    &:focus,
    &:hover {
      .close {
        width: 70%;
      }
    }
  }
}

.close {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  width: 60%;
  height: 3px;
  background-color: $chatbot-primary-color;

  &__one {
    transform: translate3d(-50%, -50%, 0px) rotate(45deg);
  }
  &__two {
    transform: translate3d(-50%, -50%, 0px) rotate(-45deg);
  }
}
